// utils
import { paramCase } from 'src/utils/change-case';
import { _id, _postTitles } from 'src/_mock/assets';

// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

const MOCK_TITLE = _postTitles[2];

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  page403: '/403',
  page404: '/404',
  page500: '/500',
  post: {
    root: `/post`,
    details: (title: string) => `/post/${paramCase(title)}`,
    demo: {
      details: `/post/${paramCase(MOCK_TITLE)}`,
    },
  },
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
    },
  },
  dashboard: {
    root: ROOTS.DASHBOARD,
    members:{
      "root": `${ROOTS.DASHBOARD}/members`,
    },
    branches:{
      "root": `${ROOTS.DASHBOARD}/branches`,
    },
    settings:{
      "root": `${ROOTS.DASHBOARD}/settings`,
    },
    interviewers: {
      root: `${ROOTS.DASHBOARD}/interviewers`,
    },
    interviews: {
      root: `${ROOTS.DASHBOARD}/interviews`,
    },
    job_position: {
      root: `${ROOTS.DASHBOARD}/job_positions`,
      show: (id: string) => `${ROOTS.DASHBOARD}/job_positions/${id}`,
      new: `${ROOTS.DASHBOARD}/job_positions/new`
    },
    applicants: {
      root: `${ROOTS.DASHBOARD}/applicants`,
      show: (id: string) => `${ROOTS.DASHBOARD}/applicants/${id}`,
    },
    interview_room: {
      show: (id: string) => `${ROOTS.DASHBOARD}/interview_room/${id}`,
    },
    account: {
      root: `${ROOTS.DASHBOARD}/account`,
      general: `${ROOTS.DASHBOARD}/account?tab=general`,
      billing: `${ROOTS.DASHBOARD}/account?tab=billing`,
      notifications: `${ROOTS.DASHBOARD}/account?tab=notifications`,
      security: `${ROOTS.DASHBOARD}/account?tab=security`,
    },
    user: {
      root: `${ROOTS.DASHBOARD}/users/`
    },
  },
  interview_page: {
    prepare: (id: string) => `/interviews/${id}/prepare`
  },
  invitations:{
    validate: '/invitations/validate'
  },
  confirmations:{
    confirm: '/users/confirmation'
  },
  password_reset:{
    reset: '/users/password_reset'
  }
};
